module.exports = __webpack_public_path__ + "img/icon-requests.21dcc85b.svg";